module.exports = __webpack_public_path__ + "62b043c27daea8dcd4aaa98d6f777396.png";